import styled from 'styled-components';

export const WidgetContainer = styled.div`
  background: ${(props) => props.theme.colorNeutralBackground1};
  display: flex;
  flex-direction: column;
  height: fit-content;
  border-radius: 1px;
  width: 100%;
`;
